<script setup lang="ts">
import { Cell, IndexAnchor, IndexBar } from 'vant';
import { onMounted } from 'vue';
import { ref } from 'vue';
import IndexComponent from './indexComponent.vue';
import countryJson from '@/assets/country.json'
import { computed } from 'vue';


const alphabetArray = ref<any[]>([]);
const searchWord = ref<string>('');


const emit = defineEmits(['update:isShow', 'selectCode'])

const props = defineProps({
  isShow: Boolean,
})

onMounted(() => {
  // 创建一个包含二十六个英文字母的数组
  const _arr = Array.from(Array(26), (_, i) => String.fromCharCode('A'.charCodeAt(0) + i));
  alphabetArray.value = _arr
})

// 字符串筛选国家地区
const countryList = computed((item: any) => {
  if (searchWord.value) {
    const _arr = countryJson.filter((item: any) => {
      if (`${item.name_en}${item.name_cn}${item.country_code}`.includes(searchWord.value)) {
        return item
      }
    })
    return _arr
  } else {
    return countryJson
  }

})


const emitCountryCode = (code: string) => {
  emit('selectCode', code)
}

const closeSlider: Function = (): void => {
  emit('update:isShow', false)
}


const getCountryList = (alphabet:string) => {
  return countryList.value.filter((item: any) => {
    return item.name_en.substring(0, 1) === alphabet
  })
}


</script>

<template>
  <div class="country-code-slider" :class="{ 'z-show': isShow }">
    <div class="slider-header">
      <span class="back" @click="closeSlider()"></span>
      <div class="title">国家/地区</div>
    </div>
    <div class="search-bar">
      <div class="inputer flex-row-start-center">
        <i class="search-icon"></i> <input type="text" placeholder="搜索" v-model="searchWord">
      </div>
    </div>
    <IndexBar :sticky="false">
      <template v-for="item in alphabetArray">
        <IndexAnchor :index="item" v-if="getCountryList(item).length" />
        <Cell :value="`+${item2.country_code}`" v-for="item2 in getCountryList(item)" :key="item2.country_id"  @click="emitCountryCode(item2.country_code)">
          <template #title>
            <div class="flex-row-start-center">
              <img class="cell-img" :src="item2.flag_icon" alt="">
              <span class="country-text">{{ item2.name_en }}</span>
            </div>
          </template>
        </Cell>
      </template>
    </IndexBar>
  </div>
</template>

<style lang="scss" scoped>
// 选择国家/地区
.country-code-slider {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 99;
  background-color: #070B14;
  overflow-y: scroll;
  right: -100%;
  transition: right 0.4s;


  &.z-show {
    right: 0;

    :deep(.van-index-bar__sidebar) {
      right: 0;
    }
  }

  :deep(.van-index-bar__sidebar) {
    right: -100%;
  }

  :deep(.van-index-anchor) {
    background-color: #1F212D;
    color: #9C9CAA;
  }

  :deep(.van-index-bar) {
    height: calc(100vh - 110px);
    overflow-y: scroll;
  }

  :deep(.van-index-bar__index) {
    color: #565662;
    font-size: 12px;
  }

  .slider-header {
    position: relative;
    height: 44px;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .back {
      width: 24px;
      height: 24px;
      background: url(../assets/back-icon-white.svg);
      background-repeat: no-repeat;
      background-size: contain;
    }

    .title {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #FFF;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
    }
  }

  .search-bar {
    padding: 6px 15px 18px 15px;

    .inputer {
      width: 100%;
      height: 38px;
      background-color: #1F212D;
      padding: 10px 15px;
      border-radius: 10px;

      .search-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url(../assets/search-icon.svg);
        background-repeat: no-repeat;
        background-size: contain;
        margin-right: 8px;
      }

      input {
        font-size: 14px;
        color: #fff;

        &::placeholder {
          color: #565662;
        }
      }
    }
  }
}


.cell-img {
  width: 40px;
  margin-right: 10px;
}

.country-text {
  width: max-content;
}

.van-cell {
  background-color: #070B14;
  color: #FFF;
  font-size: 14px;
  font-weight: 500;

  &:active {
    background: rgba($color: #fff, $alpha: .1);
  }

  &::after {
    border-bottom: 1px solid rgba($color: #fff, $alpha: .1);
  }

  :deep(.van-cell__value) {
    color: #FFF;
    font-size: 14px;
    font-weight: 500;
    margin-right: 10px;
  }
}
</style>
